import './CensusContent.css'
import React, { useRef, useEffect, useState, useCallback } from 'react';
import Blur from 'react-css-blur'
import bulb from '../assets/bulb.svg'
import people from '../assets/people.svg'
import { Bar } from "react-chartjs-2";
import { BarElement,  CategoryScale, Chart,Legend, LinearScale,Title, Tooltip } from "chart.js";
import BasicTable from "./Table";
import CreateBarData from "./BarGraph";



let CommaNumber = new Intl.NumberFormat('en-US', {
    roundingMode: 'halfCeil',
    maximumFractionDigits: 1
});


const report = {
    block_analysis : {
        exposedpop_tract : {
            column_disp_name: "Exposed Population",
            value: 10000,
            column_desc: "Number of people exposed to more than 1 ft of flooding from the 1% annual chance flood hazard."
        },
        exposedpropvalue_tract : {
            column_disp_name : "Exposed Property Value",
            value : 100000000.32,
            column_desc: "The value of property exposed to more than 1 ft of flooding from the 1% annual chance flood hazard. Property values are based on county assessor records."
        },
        flooded_parcels_tract : {
            column_disp_name : "Exposed Land Parcels",
            value : 6,
            column_desc : "Number of land parcels exposed to more than 1 ft of flooding from the 1% annual chance flood hazard."
        },
        ndi_pctl_tract : {
            column_disp_name : "Neighborhood Disadvantage Percentile",
            value : 25,
            column_desc : "Neighborhood disadvantage is a measure of socioeconomic disadvantage, and higher percentiles imply a higher level of disadvantage. A percentile of 50 corresponds to the nationwide median (or average) level."
        },
        driver_tract : {
            column_disp_name : "Dominant Hazard Driver",
            value : "Rain",
            column_desc : ""
        },
        parcels_tract : {
            column_disp_name : "Number of Land Parcels",
            value : 15,
            column_desc : "Number of land parcels in the census tract."
        },
        propvalue_tract : {
            column_disp_name : "Total Assessed Property Value",
            value : 500000000,
            column_desc : "Total assessed property value within the census tract"
        },
        pop_tract : {
            column_disp_name : "Total Population",
            value : 5000,
            column_desc : "Total population in the census tract"
        },
        percent_asian : {
            column_disp_name : "Asian",
            value: 20,
            column_desc : "Percentage of the population that identifies as Asian by race."
        },
         percent_white : {
            column_disp_name : "White",
            value: 28,
            column_desc : "Percentage of the population that identifies as White by race."
        },
         percent_black : {
            column_disp_name : "Black",
            value: 17,
            column_desc : "Percentage of the population that identifies as Black by race."
        },
         percent_hispanic : {
            column_disp_name : "Hispanic",
            value: 23,
            column_desc : "Percentage of the population that identifies as Hispanic by race."
        },
         percent_other : {
            column_disp_name : "Other",
            value: 40,
            column_desc : "Percentage of the population that identifies as Other by race."
        }


    },
    parcel_analysis : {

    }
}








export default function CensusContent(props) {

    function createData(name, value, desc) {
      return {name: name, value: value, desc: desc};
    }

    const rows_insights = [
      createData(props.census['exposedpop_tract']['column_disp_name'], CommaNumber.format(props.census['exposedpop_tract']['value']), props.census['exposedpop_tract']['column_desc']),
      createData(props.census['exposedpropvalue_tract']['column_disp_name'], `$${CommaNumber.format(props.census['exposedpropvalue_tract']['value'])}`, props.census['exposedpropvalue_tract']['column_desc']),
      createData(props.census['flooded_parcels_tract']['column_disp_name'], CommaNumber.format(props.census['flooded_parcels_tract']['value']), props.census['flooded_parcels_tract']['column_desc']),
      createData(props.census['ndi_pctl_tract']['column_disp_name'], props.census['ndi_pctl_tract']['value'], props.census['ndi_pctl_tract']['column_desc']),
      createData(props.census['driver_id']['column_disp_name'], props.census['driver_id']['value'], props.census['driver_id']['column_desc']),
    ];

    const rows_census = [
      createData(props.census['parcels_tract']['column_disp_name'], CommaNumber.format(props.census['parcels_tract']['value']), props.census['parcels_tract']['column_desc']),
      createData(props.census['propvalue_tract']['column_disp_name'], `$${CommaNumber.format(props.census['propvalue_tract']['value'])}`, props.census['propvalue_tract']['column_desc']),
      createData(props.census['pop_tract']['column_disp_name'], CommaNumber.format(props.census['pop_tract']['value']), props.census['pop_tract']['column_desc']),
    ];

    return (
                <div className='content' data-testid="overviewcontent-test">
                    <div className='insights-section'>
                        <div className='header1'>
                            <img src={bulb} className='icon'></img>Zeppelin Insights
                        </div>
                        <div>
                            <BasicTable content={rows_insights}></BasicTable>
                        </div>
                    </div>
                    <div className="census section">
                        <div className='header1'>
                            <img src={people} className='icon'></img>Census Tract Profile
                        </div>
                        <div>
                            <BasicTable content={rows_census}></BasicTable>
                        </div>
                        <div className="Population-breakdown">
                            <div className='header2'>
                                Population Breakdown by Social Groups
                                <div className='header3'>
                                    (US Census 2020)
                                 </div>
                            </div>
                            <div className='population-graph'>
                                <CreateBarData census={props.census}></CreateBarData>
                            </div>
                        </div>
                    </div>
                </div>
    )
}